export default {
  id: "aftergrass",
  pride: 37888,
  slug: "aftergrass",
  category: "vrchat",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "Aftergrass 残响草地",
    en: "Aftergrass"
  },
  image: require('@/assets/images/vrc_aftergrass.webp'),
  descriptionKey: {
    zh: "纯白天空下，无垠的草地会看见你。走远一点，你会看到一些不该看到的东西。",
    en: "Under a heaven washed in white, the boundless fields will catch sight of you. Stray but a step beyond, and your eyes will fall upon what they should never have known."
  },
  date: { year: 2025, month: 10 },
  genres: ["艺术", "冥想", "纪念"],
  themes: ["平静", "回忆"],
  engine: "Unity (VRChat)",
  platform: ["PCVR", "Quest"],
  achievements: [
    { zh: "总访问量 400+ 次", en: "400+ Total Visits" }
  ],
  developerNotesKey: {
    zh: "处女作，艺术向冥想/纪念世界。我觉得做的挺好的，但感觉留存没做好，总访问量四百次。",
    en: "Debut work, an art-oriented meditation/memorial world. I think it's well-made, but retention wasn't great. Total visits around 400."
  },
  tags: ["VRChat"],
  longDescriptionKey: {
    zh: "VRChat 处女作，艺术向冥想/纪念世界。纯白天空下，无垠的草地会看见你。走远一点，你会看到一些不该看到的东西。",
    en: "VRChat debut, an art-oriented meditation/memorial world. Under a heaven washed in white, the boundless fields will catch sight of you. Stray but a step beyond, and your eyes will fall upon what they should never have known."
  },
  links: [
    { type: "vrchat", url: "https://vrchat.com/home/world/wrld_472d0b1a-a8da-4525-9c4b-f29f90ec6a2b/info", textKey: { zh: "VRChat 访问", en: "Visit in VRChat" } }
  ]
};
